import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import BlogSection from './components/BlogSection';
import MoreArticles from './components/MoreArticles';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import Footer from './components/Footer';
import { SITE_URL } from '@/constants';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Itaobuy Spreadsheet Italia",
  "url": SITE_URL,
  "description": "La guida italiana più completa su Itaobuy Spreadsheet: recensioni, confronti, tutorial e analisi sulla sicurezza per utenti italiani.",
  "inLanguage": "it",
  "publisher": {
    "@type": "Organization",
    "name": "Itaobuy Spreadsheet Italia",
    "url": SITE_URL
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_URL}/?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Itaobuy Spreadsheet Italia",
  "url": SITE_URL,
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg",
  "description": "La guida italiana più completa su Itaobuy Spreadsheet: recensioni, confronti, tutorial e analisi sulla sicurezza per utenti italiani.",
  "sameAs": [
    "https://itaobuyspread.space"
  ]
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(homeJsonLd)
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(orgJsonLd)
        }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <AboutSection />
      <BlogSection />
      <MoreArticles />
      <CTASection />
      <TestimonialSection />
      <Footer />
    </main>
  );
}